import { createApi } from '@reduxjs/toolkit/query/react';

import { INTERNAL_ERROR_STATUS_CODE } from '@/constants';
import { normalizeOrganizationsBySlugData } from '@/normalize';
import { getOrgListApiRequestUrl, getOrgV2RequestUrl, request } from '@/utils';

export const organizationsApi = createApi({
  reducerPath: 'organizations',
  endpoints: (builder) => ({
    getOrganizationsList: builder.query({
      queryFn: async ({ locale }) => {
        try {
          const response = await request(
            getOrgListApiRequestUrl({
              locale,
            })
          );

          return {
            data: response?.data || {},
          };
        } catch (error) {
          console.error('getOrganizationsList error:', error);

          return {
            error: {
              status: error?.response?.status || INTERNAL_ERROR_STATUS_CODE,
            },
          };
        }
      },
    }),

    getOrganizationBySlug: builder.query({
      queryFn: async ({ locale, slug }) => {
        if (!locale || !slug) {
          return {
            error: {
              status: 500,
              message: 'Missing required parameters: locale or slug',
            },
          };
        }
        try {
          const response = await request(
            getOrgV2RequestUrl({
              locale,
              slug,
            })
          );

          return {
            data: normalizeOrganizationsBySlugData({
              data: response?.data,
              locale,
            }),
          };
        } catch (error) {
          console.error(error);

          return {
            error: {
              status: error?.response?.status || INTERNAL_ERROR_STATUS_CODE,
            },
          };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetOrganizationsListQuery,
  useGetOrganizationBySlugQuery,
  util: { getRunningQueriesThunk: getRunningOperationPromisesOrganization },
} = organizationsApi;

// export endpoints for use in SSR
export const { getOrganizationsList, getOrganizationBySlug } =
  organizationsApi.endpoints;
